import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NumberService {

  constructor() { }
  /** 숫자의 자릿수를 맞추기위한 함수 */
  fix(number, length, min = 0, max = null) {
    let sNumber = String(number);
    sNumber = String(sNumber).replace(/[^0-9]/g, '');
    if (sNumber.length < length) sNumber = new Array(length - sNumber.length).fill(0).join('') + sNumber;
    else sNumber = sNumber.slice(-length);
    if(max && Number(sNumber) > max) sNumber = String(max);
    return sNumber;
  }
}
